import _sfc_main from "./DialogPC.vue2.mjs";
/* empty css               */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.visible, expression: "visible" }], ref: "dialogRef", staticClass: "overlay-container", class: [_vm.modal && "overlay"], style: _setup.overlayContainerStyle, on: { "click": _setup.handleOverlayClick } }, [_c("div", { staticClass: "tui-dialog-container", style: _setup.drawerContainerStyle }, [_c("div", { staticClass: "tui-dialog-header" }, [_c("div", { staticClass: "tui-dialog-header-title" }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.$slots.title ? [_vm._t("title")] : _vm._e(), _vm.showClose ? _c("div", { staticClass: "close" }, [_c(_setup.SvgIcon, { attrs: { "size": 16 }, on: { "click": _setup.handleClose } }, [_c(_setup.CloseIcon)], 1)], 1) : _vm._e()], 2), _c("div", { staticClass: "tui-dialog-content" }, [_vm._t("default")], 2), _vm.$slots.footer ? [_c("div", { staticClass: "tui-dialog-footer" }, [_vm._t("footer")], 2)] : _vm._e()], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8368f60e"
);
const DialogPC = __component__.exports;
export {
  DialogPC as default
};
